import { css } from '@emotion/css';

export const buttonRootStyles = css`
  border-radius: 1.2rem;
  max-width: 29.4rem;
`;
